/* @flow */

export const commonEmails = {
  gmail: 'https://mail.google.com',
  yahoo: 'https://login.yahoo.com',
  hotmail: 'https://login.live.com',
  qq: 'https://mail.qq.com',
  '163': 'https://mail.163.com',
  sina: 'https://mail.sina.com.cn',
};

// $FlowFixMe
export const getEmailName = (email: string) => email?.match(/@(\S*)\./)[1];

export const format = (email: string) => {
  if (!email) email = String();
  const addonBefore = email.substr(0, 2);
  const addonAfter = email.split('.');
  const afterStr = addonAfter[addonAfter.length - 1];
  return `${addonBefore}***@***.${afterStr}`;
};

export default {
  format,
  commonEmails,
  getEmailName,
};
